import Appbar from 'components/appbar/Appbar';
import PageHeader from 'components/page-header/PageHeader';
import React from 'react';
import ReportSurgerieTotal from './ReportSurgerieTotal';
import { useFetchReportSurgeries } from './hooks/useFetchReportSurgeries';
import ReportSurgerieFilterBox from './ReportSurgerieFilterBox';
import { ReportSurgerieProvider } from './hooks/useReportSurgerie';
import Pagination from 'components/pagination/Pagination';
import { useDisplayMode } from 'hooks/useDisplayMode';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';
import PaginationProvider from 'hooks/pagination';
import ReportSurgerieListTable from './list/table/ReportSurgerieListTable';
import ReportSurgerieListModule from './list/module/ReportSurgerieListModule';
import { styled } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
  boxShadow: '0 10px 24px rgba(15, 23, 42, 0.05)',
  '& > p': {
    padding: theme.spacing(3),
  },
}));

const ReportSurgerie: React.FC = () => {
  const {
    filter,
    handleChange,
    loading,
    handleSearch,
    handleSort,
    surgeries,
    anchorEl,
    setAnchorEl,
    selectedSurgerie,
    setSelectedSurgerie,
    page,
    rows,
    total,
    setPage,
    setRows,
  } = useFetchReportSurgeries();
  const [displayMode] = useDisplayMode();
  const paginatedSurgeries = surgeries.slice(page * rows, page * rows + rows);

  return (
    <ReportSurgerieProvider
      value={{
        filter,
        handleChange,
        handleSearch,
        surgeries,
        loading,
        anchorEl,
        setAnchorEl,
        setSelectedSurgerie,
        selectedSurgerie,
      }}
    >
      <Appbar title="Relatórios - Orçamentos cirúrgicos" />
      <PageHeader
        title="Orçamentos Cirúrgicos"
        description="Analise de vendas, pagamentos e volume cirúrgico"
        backUrl="/reports"
      />

      <ReportSurgerieTotal />

      <ReportSurgerieFilterBox
        filter={filter}
        handleChange={handleChange}
        handleSearch={handleSearch}
        loading={loading}
      />

      {loading ? (
        displayMode === 'list' ? (
          <TableLoading />
        ) : (
          <ModuleLoading />
        )
      ) : surgeries.length === 0 ? (
        <NoData message="Relatório indisponível" />
      ) : (
        <PaginationProvider rowsPerPage={rows}>
          <Container>
            {displayMode === 'list' ? (
              <ReportSurgerieListTable surgeries={paginatedSurgeries} />
            ) : (
              <ReportSurgerieListModule surgeries={paginatedSurgeries} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </Container>
        </PaginationProvider>
      )}
    </ReportSurgerieProvider>
  );
};

export default ReportSurgerie;
